import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AppRouter } from '@/router/AppRouter';
import { DataModeProvider, DataModeIndicator } from '@/providers/DataModeProvider';
import { RoutedErrorBoundary } from '@/components/RootErrorBoundary';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Main SupportDesk Application Component
 * 
 * Sets up the application with routing, authentication, and global state.
 * Provides React Query for data fetching and caching.
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Router>
          <RoutedErrorBoundary>
            <DataModeProvider>
              <AuthProvider>
                <AppRouter />
                <DataModeIndicator />
              </AuthProvider>
            </DataModeProvider>
          </RoutedErrorBoundary>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;